export const duckFinds = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Sugar Hill Community Park",
    caption: "Found this little guy hiding on a park bench! Made my whole morning 🦆",
    date: "June 28, 2025",
    image: "https://public.readdy.ai/ai/img_res/4b450962fb5e43ca0529bb2ce7432cc7.jpg"
  },
  {
    id: 2,
    name: "Tanya R.",
    location: "Suwanee Town Center",
    caption: "Spotted this cutie near the fountain! My kids were SO excited 🦆💛",
    date: "June 25, 2025",
    image: "https://readdy.ai/api/search-image?query=tiny%20yellow%20rubber%20duck%20placed%20near%20a%20decorative%20outdoor%20fountain%20in%20a%20town%20square%20sunny%20day%20cheerful%20colorful%20scene%20with%20stone%20pavement&width=400&height=400&seq=duck002&orientation=squarish"
  },
  {
    id: 3,
    name: "Monique D.",
    location: "Buford Library",
    caption: "Someone left this duck on the children's book shelf. Cutest thing ever! 📚🦆",
    date: "June 22, 2025",
    image: "https://readdy.ai/api/search-image?query=small%20yellow%20rubber%20duck%20sitting%20on%20a%20colorful%20library%20bookshelf%20among%20children%20books%20warm%20indoor%20lighting%20cozy%20and%20fun%20atmosphere&width=400&height=400&seq=duck003&orientation=squarish"
  },
  {
    id: 4,
    name: "Brianna K.",
    location: "Coolray Field, Lawrenceville",
    caption: "Found at the baseball game! My son thought it was a prize 😂🦆",
    date: "June 20, 2025",
    image: "https://readdy.ai/api/search-image?query=yellow%20rubber%20duck%20sitting%20on%20a%20stadium%20bleacher%20seat%20at%20a%20baseball%20field%20sunny%20afternoon%20fun%20and%20playful%20scene%20with%20green%20field%20in%20background&width=400&height=400&seq=duck004&orientation=squarish"
  },
  {
    id: 5,
    name: "Latoya W.",
    location: "Peachtree Ridge Park",
    caption: "This duck was perched on the playground slide. Absolute joy! 🦆🌸",
    date: "June 18, 2025",
    image: "https://readdy.ai/api/search-image?query=small%20yellow%20rubber%20duck%20sitting%20at%20the%20top%20of%20a%20colorful%20playground%20slide%20outdoors%20bright%20sunny%20day%20cheerful%20playful%20scene%20with%20blue%20sky&width=400&height=400&seq=duck005&orientation=squarish"
  },
  {
    id: 6,
    name: "Jasmine T.",
    location: "Duluth Town Green",
    caption: "Found during our Saturday farmers market run. Best surprise! 🦆🥕",
    date: "June 15, 2025",
    image: "https://readdy.ai/api/search-image?query=tiny%20yellow%20rubber%20duck%20placed%20on%20a%20farmers%20market%20table%20surrounded%20by%20fresh%20vegetables%20and%20flowers%20outdoor%20market%20setting%20bright%20and%20colorful&width=400&height=400&seq=duck006&orientation=squarish"
  },
  {
    id: 7,
    name: "Keisha P.",
    location: "Gwinnett Place Mall",
    caption: "Sitting right on the mall bench like it owned the place 😂🦆",
    date: "June 12, 2025",
    image: "https://readdy.ai/api/search-image?query=small%20yellow%20rubber%20duck%20sitting%20on%20a%20mall%20bench%20indoor%20shopping%20center%20bright%20lights%20cheerful%20fun%20scene%20with%20shoppers%20in%20background&width=400&height=400&seq=duck007&orientation=squarish"
  },
  {
    id: 8,
    name: "Amber N.",
    location: "Tribble Mill Park",
    caption: "Found this duck by the lake trail. Nature walk just got better 🦆🌿",
    date: "June 10, 2025",
    image: "https://readdy.ai/api/search-image?query=yellow%20rubber%20duck%20sitting%20on%20a%20wooden%20trail%20post%20near%20a%20lake%20surrounded%20by%20lush%20green%20trees%20and%20nature%20peaceful%20outdoor%20setting%20sunny%20day&width=400&height=400&seq=duck008&orientation=squarish"
  },
  {
    id: 9,
    name: "Danielle F.",
    location: "Snellville Towne Center",
    caption: "My daughter spotted it first and screamed with joy! 🦆💕",
    date: "June 8, 2025",
    image: "https://readdy.ai/api/search-image?query=small%20yellow%20rubber%20duck%20placed%20on%20a%20decorative%20planter%20outside%20a%20shopping%20center%20colorful%20flowers%20around%20it%20bright%20sunny%20day%20cheerful%20scene&width=400&height=400&seq=duck009&orientation=squarish"
  }
];
